import { CSSObject } from "@emotion/react";

import { partialCtaDefaultLinearGradientBackground } from "../AiComponents.style";

import { gradientBackgrounds } from "../AiComponents.style";

export const buttonWithPopOutRootCss: CSSObject = {
  display: "block",
  "&:hover": {
    path: {
      stroke: "none",
    },
  },
};

export const buttonIconContainerCss: CSSObject = {
  borderRadius: "10px",
  padding: "1px",
  ...partialCtaDefaultLinearGradientBackground,
};

export const buttonIconBorderCss: CSSObject = {
  borderRadius: "10px",
  padding: "6px 8px",

  background: gradientBackgrounds[100],
};

export const searchToggleButtonSvgCss: CSSObject = {
  width: "28px",
  height: "28px",
};

export const popOutCss: CSSObject = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
};
